export default __webpack_public_path__ + "assets/f43cc1efb6cc6bad78311b62828e94ef.png";